const addPluralLetter = (letter:string, numItems:number) => {
  if (numItems > 1) return letter;
  return null;
};

export default addPluralLetter;
